//@flow
import React from 'react'
import DataTable from 'react-data-table-component'
import { Celllinie } from '../Celllinie'
import Tippy from '@tippyjs/react'
import 'tippy.js/dist/tippy.css' // optional
import questionMark from './images/question-mark.svg'
import { SwapArrows } from './images/swap'
import './styles.scss'
import sbbData from 'data/verbindungen.json'


// console.log('sbbData:', sbbData)
const startStations = [...new Set(sbbData.map(route => route.BH_Start_DE).sort())]
const endStations = [...new Set(sbbData.map(route => route.BH_End_DE).sort())]

let columns = [
    {
      name: 'Strecke',
      id: 'strecke',
      selector: row => row.Strecke_DE,
    },
    {
      name: 'Linie',
      id: 'linie',
      selector: row => row.LINIEN_TEXT
    },
    {
      name: 'Fahrzeit',
      id: 'fahrzeit',
      selector: row => row.Fahrtzeit_min,
    },
    {
      name: 'Verspätung<br />Ankunft',
      id: 'verspaetung',
      selector: row => row.Verspätung_valid_mean_rob,
    },
    {
      name: 'Pünktlichkeit',
      id: 'puenktlichkeit',
      selector: row => row.Anteil_Verspätung_valid_3,
    },
  ]


const paginationComponentOptions = {
  rowsPerPageText: 'Zeilen pro Seite',
  rangeSeparatorText: 'von',
  selectAllRowsItem: true,
  selectAllRowsItemText: 'Alle',
}

// https://react-data-table-component.netlify.app/?path=/docs/sorting-basic--basic


export class Resulttable extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
      displayData: sbbData,
      startStation: undefined,
      endStation: undefined,
      possibleStartStations: startStations.sort(),
      possibleEndStations: endStations.sort(),
      isSwapped: false
    }
    this.setTableCoumnOptions = this.setTableCoumnOptions.bind(this)
    this.filterStations = this.filterStations.bind(this)
    this.swapStations = this.swapStations.bind(this)
    this.updateSizes = this.updateSizes.bind(this)
  }

  setTableCoumnOptions() {
    columns = [
      {
          name: 'Strecke',
          id: 'strecke',
          selector: row => row.Strecke_DE,
          cell: row => this.state.isMobile ? <>{row.BH_Start_DE}<br />{row.BH_End_DE}</> : row.Strecke_DE,
          sortable: true,
          minWidth: this.state.isMobile ? '110px' : '240px',
          compact: true,
      },
      {
        name: <>Linie</>,
        id: 'linie',
        maxWidth: this.state.isMobile ? '60px' : '120px',
        minWidth: '60px',
        selector: row => row.LINIEN_TEXT,
        cell: row => <Celllinie linie={row.LINIEN_TEXT} start={row.BH_Start_DE} end={row.BH_End_DE} departs={row.Abfahrtszeit_clean.toString()} duration={row.Fahrtzeit_min} colorMode={this.props.colorMode} />,
        sortable: true,
        compact: true
      },
      {
        name: this.state.isMobile ? 'Dauer' : 'Fahrzeit',
        id: 'fahrzeit',
        minWidth: '40px',
        selector: row => row.Fahrtzeit_min,
        sortable: true,
        compact: true,
        hide: 'sm'
      },
      {
        name: <div>Verspätung<br /> Ankunft ⌀</div>,
        id: 'verspaetung',
        maxWidth: this.state.isMobile ? '80px' : '120px',
        minWidth: '60px',
        selector: row => row.Verspätung_valid_mean_rob,
        cell: row => row.Verspätung_valid_mean_rob >= 60 ? <div className='minutes'>{this.secondsToMinutes(row.Verspätung_valid_mean_rob)}</div> : <div className='seconds'>{row.Verspätung_valid_mean_rob < 0 ? row.Verspätung_valid_mean_rob : '+'+row.Verspätung_valid_mean_rob}</div>,
        center: true,
        sortable: true,
        compact: true
      },
      {
        name: <div>Anteil<br />pünktlich</div>,
        id: 'puenktlichkeit',
        maxWidth: this.state.isMobile ? '80px' : '120px',
        minWidth: '70px',
        selector: row => 100-row.Anteil_Verspätung_valid_3,
        cell: row => <span className={row.Anteil_Verspätung_valid_3 > 7 ? 'critical' : 'ok'}>{100-row.Anteil_Verspätung_valid_3}</span>,
        center: true,
        sortable: true,
        compact: true
      },
    ]
  }

  secondsToMinutes(seconds) {
    const isNegative = seconds < 0 ? true : false
    const secondsClean = isNegative ? -seconds : seconds
    const minutes = Math.floor(secondsClean / 60)
    const minutesOutput = isNegative ? '-'+minutes : '+'+minutes
    const secondsLeft = minutes >= 0 ? secondsClean - minutes * 60 : secondsClean
    const secondsOutput = (secondsLeft > 9) ? secondsLeft : '0'+secondsLeft
    return minutesOutput+':'+secondsOutput
  }

  filterStations(start, end) {
    // console.log('filterStations: start:', start, 'end:', end)
    this.setState({
      startStation: start,
      endStation: end
    }, function() {
      let possibleEndStations = [...new Set(sbbData.map(route => route.BH_End_DE))]
      if(start !== 'all') {
        // get possible END stations from selected start station
        let possibleEndRoutes = sbbData.filter(function (el) {
          return el.BH_Start_DE === start
        })
        possibleEndStations = [...new Set(possibleEndRoutes.map(route => route.BH_End_DE))]
      }

      let possibleStartStations = [...new Set(sbbData.map(route => route.BH_Start_DE))]
      if(end !== 'all') {
        // get possible START stations from selected start station
        let possibleStartRoutes = sbbData.filter(function (el) {
          return el.BH_End_DE === end
        })
        possibleStartStations = [...new Set(possibleStartRoutes.map(route => route.BH_Start_DE))]
      }

      this.setState({
        possibleStartStations: possibleStartStations.sort(),
        possibleEndStations: possibleEndStations.sort()
      })

      // filter data
      let filteredData = sbbData
      if(start !== undefined && start !== 'all') {
        filteredData = filteredData.filter(function (el) {
          return el.BH_Start_DE === start
        })
      }
      if(end !== undefined && end !== 'all') {
        filteredData = filteredData.filter(function (el) {
          return el.BH_End_DE === end
        })
      }

      this.setState({
        displayData: filteredData
      })
    })
  }

  swapStations() {
    // console.log('swapStations')
    const prevStartStation = this.state.startStation
    const prevEndStation = this.state.endStation
    this.filterStations(prevEndStation, prevStartStation)
    this.setState({ isSwapped: !this.state.isSwapped })
  }
  
  updateSizes() {
    this.setState({
      isMobile: window.innerWidth < 711
    }, function() {
      this.setTableCoumnOptions()
    })
  }
  
  componentDidMount() {
    this.setState({
      startStation: this.props.tenant.key === 'tagesanzeiger' ? 'Zürich' :
                    this.props.tenant.key === 'zsz' ? 'Zürich' :
                    this.props.tenant.key === 'zuonline' ? 'Zürich' :
                    this.props.tenant.key === 'landbote' ? 'Winterthur' :
                    this.props.tenant.key === 'bazonline' ? 'Basel' :
                    this.props.tenant.key === 'bernerzeitung' ? 'Bern' :
                    this.props.tenant.key === 'langenthalertagblatt' ? 'Bern' :
                    this.props.tenant.key === 'berneroberlaender' ? 'Bern' :
                    this.props.tenant.key === 'thunertagblatt' ? 'Thun' :
                    this.props.tenant.key === 'derbund' ? 'Bern' : undefined 
   }, function() {
     this.filterStations(this.state.startStation, 'all')
   })

   window.addEventListener('resize', this.updateSizes)
  this.updateSizes()
  }

  render() {
    // console.log('displayData:', this.state.displayData)
    // console.log('von:', this.state.startStation, 'nach:', this.state.endStation)
    return <div className='resulttable'>

        <div className='call'>
          <h3 className='centered'>Wählen Sie eine Strecke</h3>
            <Tippy
              content={<div dangerouslySetInnerHTML={{__html: '<p>Unsere Analyse beschränkt sich auf die wichtigsten Pendlerstrecken.</p><p>Wenn Ihr Start- oder Endbahnhof nicht aufgeführt wird, <u>wählen Sie bitte den nächstgrösseren Bahnhof</u> auf Ihrer Strecke.</p>'}} />}
              className='tooltip'
              trigger={this.state.isMobile ? 'click' : 'mouseenter'}
              placement={'bottom'}
              offset={[0, 0]}
              maxWidth={250}
              theme={'ta'}
              interactive={true}
            >
            <div className='explanation centered'><img className='icon' src={questionMark} alt='icon' />mein Bahnhof ist nicht aufgeführt</div>
          </Tippy>
        </div>

        <div className='choose'>

          <div className='chooser start'>
            <div className='label'>Von</div>
            <select
              id='start-stations'
              className={this.state.startStation === 'all' ? 'all' : 'normal'}
              value={this.state.startStation}
              onChange={(event) => {
                this.filterStations(event.target.value, this.state.endStation)
              }}>
                <option
                    key={'all'}
                    value={'all'}
                  >
                   - alle -
                </option>
                {this.state.possibleStartStations.map((station, index) => (
                    <option
                      key={station}
                      value={station}
                    >
                      {station}
                    </option>
                ))}
            </select>
          </div>

          <div className={this.state.isSwapped ? 'swapper flipped' : 'swapper'} onClick={this.swapStations}>
            {this.state.endStation && (
              <SwapArrows />
            )}
          </div>

          {this.state.startStation !== undefined && (
            <div className='chooser end'>
              <div className='label'>Nach</div>
              <select
                id='end-stations'
                className={this.state.endStation === 'all' ? 'all' : 'normal'}
                value={this.state.endStation}
                onChange={(event) => {
                  this.filterStations(this.state.startStation, event.target.value)
                }}>
                  <option
                    key={'all'}
                    value={'all'}
                  >
                   - alle -
                  </option>
                  {this.state.possibleEndStations.map((station, index) => (
                    <option
                      key={station}
                      value={station}
                    >
                      {station}
                    </option>
                ))}
              </select>
            </div>
          )}

        </div>

        <div className="counter">{this.state.displayData.length} Verbindung{this.state.displayData.length > 1 && (<>en</>)}</div>
        <DataTable
            columns={columns}
            data={this.state.displayData}
            defaultSortFieldId={'puenktlichkeit'}
            defaultSortAsc={true}
            pagination={this.state.displayData.length > 75}
            paginationPerPage={this.state.displayData.length > 75 ? 50 : 100}
            paginationRowsPerPageOptions={[50, 100, 200]}
            paginationComponentOptions={paginationComponentOptions}
            // dense
            noDataComponent='Keine Daten vorhanden' //or your component
        />
        <div className='note'>
          <div>Als pünktlich gilt ein Zug, wenn er weniger als 3 Minuten zu spät am Zielort ankommt.</div>
          <div>Nur Fahrten während der Pendlerzeiten berücksichtigt.</div>
        </div>
      </div>
  }
}



             